import React from "react";

import { getAutomationDataAttr } from "@/utils/automationUtils";

import "./styles.scss";

const ListViewNav = (props) => {
  let classes = "ListNav__item fs-18 fs-lg-14 tw:font-bold d-inline";

  const { status, tabs } = props;

  return props.centered ? (
    <nav
      className="ListNav__centered d-flex d-lg-block tw:justify-center"
      data-public="true"
      {...getAutomationDataAttr("patient-chart-header-tabs")}
    >
      <ul className="d-flex tw:justify-center">
        {tabs.map((listTextTitle, index) => {
          let isActive = listTextTitle === status;

          return (
            <li
              className={`${classes} centered ${isActive ? "active" : ""}`}
              key={index}
              onClick={() => props.ListNavHandler(listTextTitle)}
            >
              {listTextTitle}
            </li>
          );
        })}
      </ul>
    </nav>
  ) : (
    <ul className="ListNav d-flex d-lg-block tw:justify-center" data-public="true">
      {tabs.map((listTextTitle, index) => {
        let isActive = listTextTitle === status;

        return (
          <li
            className={`${classes} ${isActive ? "active" : ""}`}
            key={index}
            onClick={() => props.ListNavHandler(listTextTitle)}
          >
            {listTextTitle}
          </li>
        );
      })}
    </ul>
  );
};

export default ListViewNav;
